export { CubeTransparent as default } from './CubeTransparent';
